module.exports = __webpack_public_path__ + "static/media/ic-unverified-location-small.cb4240be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-unverified-location-small.svg
// module id = 789
// module chunks = 0